import { render, staticRenderFns } from "./VuesticScrollbar.vue?vue&type=template&id=5157b65c&"
import script from "./VuesticScrollbar.vue?vue&type=script&lang=js&"
export * from "./VuesticScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./VuesticScrollbar.vue?vue&type=style&index=0&id=5157b65c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports